// ABOUTME: TabView3 tab config for the relation Inkoopadvies page — a single grid tab of stock
// ABOUTME: forecast rows, mirroring relationInboundsConfig.
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const purchaseAdviceConfig = {
    purchaseAdvice: {
        title: 'purchase_advice',
        icon: <TrendingUpIcon/>,
        isSingleDataGrid: true,
    }
};
